

import React, { useEffect } from 'react';
import { Spin } from 'antd';

import CustomerReviews from '../../shared/CustomerReviews';
import FeaturedCampaigns from '../../shared/FeaturedCampaigns';
import TopCampaingsForCategory from '../../shared/TopCampaingsForCategory';

const CategoryFive = (props) => {
  const {
    history,
    match,
    getSubCategories,
    getCustomerReviews,
    getFeaturedCampaignsForCategoryId,
    getCategoryById,
    getTopCampaignsByCategoryId,
    subCategory
  } = props;

  const {
    subCategories: dataOfSubCategories,
    loading,
    featuredCampaigns,
    customerReviews,
    topCampaigns,
    categoryHash
  } = subCategory || {};
  const [data] = categoryHash || [];
  const {
    image,
    description,
    name,
    text1,
    text2,
    text3,
    title
  } = data || {};
  let categoryImage = '/images/boy.PNG';
  if (image) {
    categoryImage = `${process.env.REACT_APP_BACKEND_BASE_URL}/${image}`;
  }
  const { params } = match || {};
  const categoryId = params && params.id ? Number(params.id) : null;
  
  useEffect(() => {
    getCategoryById(categoryId);
    getTopCampaignsByCategoryId(categoryId);
    getFeaturedCampaignsForCategoryId(categoryId);
    getSubCategories(categoryId);
    getCustomerReviews();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div>
      <Spin spinning={loading}>
        <div className="homepage-wrap">
        <TopCampaingsForCategory 
          history={history} 
          loading={loading} 
          data={topCampaigns} 
        />
        </div>
        <FeaturedCampaigns 
          data={featuredCampaigns}
          loading={loading}
        />
        <section className="past-year">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-10 col-sm-12 mx-auto text-center">
                <h3 className="main-heading mt-4 mb-4 mt-md-0">Our Achievement Past year</h3>
                <p>The CharityPress community was named a “Top 25 Best Global Philanthropist” by Barron’s. We beat Oprah. And, Mashable named CharityPress something like “the best place to raise money online for your favorite causes.”</p>
                <h5>Our strategic priorities up to 2019 are:</h5>
                <div className="price-wraper">
                  <div className="left">
                    <h5 className="text-gren">250,000+</h5>
                    <p>Medical campaign per year</p>
                  </div>
                  <div className="right">
                    <h5 className="text-gren">$50,000</h5>
                    <p>Raised per year</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="donate-section iCause-Partners pt-4 detail-4-sec-4">
          <div className='container'>
            <div className='row d-flex align-items-center  '>
              <div className='col-lg-7 col-md-5 pl-md-5 custom-text-width'>
                <h3 className="main-heading mt-4 mb-4 mt-md-0">{name}</h3>
                <p className="" dangerouslySetInnerHTML={{ __html: title || '' }}></p>
                <p className="">{description}</p>
                <ul>
                  <li>{text1}</li>
                  <li>{text2}</li>
                  <li>{text3}</li>
                  {/* <li>Contrary to popular belief.</li> */}
                </ul>
              </div>
              <div className='col-lg-4 col-md-5 trending-causes'>
                <div className="card"> <img style={{ height: '416px', width: '344px' }} src={categoryImage} className="img-fluid" alt="" /> </div>
              </div>
            </div>
          </div>
        </section>
        <section className="Whatever-your-need text-center">
          <div className="col-xl-7 col-lg-7 mx-auto">
            <h3 className="main-heading mt-4 mb-4 mt-md-0">Whatever your need, you can get help on iCause</h3>
            <p>The CharityPress community was named a “Top 25 Best Global Philanthropist” by Barron’s. We beat Oprah. And, Mashable named CharityPress something like “the best place to raise money online for your favorite causes.”</p>
            <ul>
              {
                dataOfSubCategories && dataOfSubCategories.length ?
                  dataOfSubCategories.map(({ name, id }, index) => {
                    return (
                      <li key={index}>
                        <a href={`/sub-category/${id}`}>{name}</a>
                      </li>
                    );
                  }) : ''
              }
            </ul>
          </div>
        </section>
        <section className="donate-section bg-litgray pt-4">
          <div className='container text-center'>
            <div className='row d-flex align-items-center  '>
              <div className='col-lg-7 col-md-5   '>
                <h5 className=" mb-0  mt-md-0">iCause Fundraising Stories</h5>
                <h3 className="main-heading  mb-4 mt-md-0">Get Guardian for this kid</h3>
                <p className="">The CharityPress community was named a “Top 25 Best Global Philanthropist” by Barron’s. We beat Oprah. And, Mashable named CharityPress something like “the best place to raise money online for your favorite causes.”</p>
                <button onClick={() => history.push('/homepage')} type="button" className="btn btn-success  ">Donate now</button>
              </div>
              <div className='col-lg-4 col-md-5 trending-causes'>
                <div className="card"> <img src="/images/Trending-img-1.png" className="img-fluid" alt="" /> </div>
              </div>
            </div>
          </div>
        </section>
        <CustomerReviews
          data={customerReviews}
          loading={loading}
        />
      </Spin>
    </div>
  );
};

export default CategoryFive;
